/*
 Designed and developed by Richard Nesnass

 This file is part of PlatFAMs.

 SL+ is free software: you can redistribute it and/or modify
 it under the terms of the GNU Affero General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 GPL-3.0-only or GPL-3.0-or-later

 SL+ is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Affero General Public License for more details.

 You should have received a copy of the GNU Affero General Public License
 along with PlatFAMs.  If not, see <http://www.gnu.org/licenses/>.
 */
import pkg from '../package.json' assert { type: 'json' }
import type { Category } from '@/models'

export const appVersion: string = pkg.version //document.documentElement.getAttribute('data-appversion') || ''
export const appName: string = pkg.name

// The background colour to use for both list header and list items
export const mainBackgroundClasses = (colour?: string) => {
  switch (colour) {
    case 'none':
      return 'bg-none text-black'
    case 'green':
      return 'bg-green text-white'
    case 'blue':
      return 'bg-blue text-white'
    case 'orange':
      return 'bg-orange text-black'
    case 'light blue':
      return 'bg-lightBlue text-black'
    case 'soft blue-green':
      return 'bg-[#C3DCE769] text-black'
    case 'pink':
      return 'bg-pink text-black'
    case 'peach':
      return 'bg-peach text-black'
    case 'yellow':
      return 'bg-yellow text-black'
    case 'pale yellow':
      return 'bg-paleYellow text-black'
    case 'white':
      return 'bg-white text-black'
    case 'light brown':
      return 'bg-lightBrown text-black'
    default:
      return ''
  }
}

// Return colour information for each Category type.
// Full class names are needed to allow Tailwind to process them.
export const categoryColour = (category?: Category) => {
  switch (category) {
    case 'what':
      return {
        background: 'bg-[#32746C]',
        border: 'border-[#32746C]',
        text: 'text-white',
        after: 'after:bg-[#32746C]',
      }
    case 'how':
      return {
        background: 'bg-[#F9AA00C4]/[77%]',
        border: 'border-[#F9AA00C4]/[77%]',
        text: 'text-black',
        after: 'after:bg-[#F9AA00C4]/[77%]',
      }
    case 'who':
      return {
        background: 'bg-[#7F0103]/[70%]',
        border: 'border-[#7F0103]/[70%]',
        text: 'text-white',
        after: 'after:bg-[#7F0103]/[70%]',
      }
    case 'where':
      return {
        background: 'bg-[#D10000]/[70%]',
        border: 'border-[#D10000]/[70%]',
        text: 'text-white',
        after: 'after:bg-[#D10000]/[70%]',
      }
    case 'when':
      return {
        background: 'bg-[#04577D]/[70%]',
        border: 'border-[#04577D]/[70%]',
        text: 'text-white',
        after: 'after:bg-[#04577D]/[70%]',
      }
    case 'challenges & opportunities':
      return {
        background: 'bg-[#DC8BD7]/[63%]',
        border: 'border-[#DC8BD7]/[63%]',
        text: 'text-black',
        after: 'after:bg-[#DC8BD7]/[63%]',
      }
    default:
      return { background: 'bg-white', border: 'border-white' }
  }
}
